module.exports = __webpack_public_path__ + "img/networkTwoImg.f049d26d.png";